// extracted by mini-css-extract-plugin
var _1 = "ilReqJnWIZr8yegiuGMj";
var _2 = "dark-mode";
export { _1 as "button", _2 as "dark-mode" }
